export function debounce(fn, wait = 1) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.call(this, ...args), wait);
	};
}

export const throttle = (fn, wait) => {
	let previouslyRun;
	let queuedToRun;

	return function invokeFn(...args) {
		const now = Date.now();

		queuedToRun = clearTimeout(queuedToRun);

		if (!previouslyRun || now - previouslyRun >= wait) {
			fn(...args);
			previouslyRun = now;
		} else {
			queuedToRun = setTimeout(
				invokeFn(...args),
				wait - (now - previouslyRun)
			);
		}
	};
};

// polyfills for native async delays
const requestAnimationFrame =
	window.requestAnimationFrame ||
	window.webkitRequestAnimationFrame ||
	window.mozRequestAnimationFrame ||
	(function () {
		let clock = Date.now();

		return function (callback) {
			const currentTime = +new Date();

			if (currentTime - clock > 16) {
				clock = currentTime;
				callback(currentTime);
			} else {
				// recursion wrapped in a setTimeout here
				// to unblock the browser in between loops.
				setTimeout(() => {
					// eslint-disable-next-line
					polyfill(callback);
				}, 0);
			}
		};
	})();

const requestIdleCallback =
	window.requestIdleCallback ||
	function (cb) {
		const start = Date.now();
		return setTimeout(() => {
			cb({
				didTimeout: false,
				timeRemaining: function () {
					return Math.max(0, 50 - (Date.now() - start));
				},
			});
		}, 1);
	};

// throttle, but only fires on trailing edge, after a delay of no similar events
// throttleDomAfterAsync :: (Function, Integer, Context) -> Function
export const throttleDomAfterAsync = (fn, ms = 0) => {
	let timer = 0;
	let previouslyRun;
	return function (...args) {
		const now = Date.now();
		clearTimeout(timer);
		if (!previouslyRun || now - previouslyRun >= ms) {
			fn(...args);
			previouslyRun = now;
		} else {
			timer = setTimeout(
				() =>
					requestIdleCallback(
						() => requestAnimationFrame(() => fn(...args)),
						{
							timeout: ms,
						}
					),
				ms
			);
		}
	};
};
